import React from "react";

export function PersonPinCircleIcon() {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1332_435)">
        <path
          d="M27.5 25.208C24.4521 25.208 18.3333 26.7434 18.3333 29.7913V30.158C20.5562 32.7247 23.8333 34.3747 27.5 34.3747C31.1667 34.3747 34.4437 32.7247 36.6667 30.158V29.7913C36.6667 26.7434 30.5479 25.208 27.5 25.208ZM27.5 22.9163C30.0208 22.9163 32.0833 20.8538 32.0833 18.333C32.0833 15.8122 30.0208 13.7497 27.5 13.7497C24.9792 13.7497 22.9167 15.8122 22.9167 18.333C22.9167 20.8538 24.9792 22.9163 27.5 22.9163ZM27.5 4.58301C37.125 4.58301 45.8333 11.9622 45.8333 23.3747C45.8333 30.6622 40.2187 39.233 29.0125 49.1101C28.1417 49.8663 26.8354 49.8663 25.9646 49.1101C14.7812 39.233 9.16666 30.6622 9.16666 23.3747C9.16666 11.9622 17.875 4.58301 27.5 4.58301Z"
          fill="white"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1332_435">
          <rect width="55" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
